import { defineStore } from 'pinia'
import axios from 'axios'
import { $t } from 'boot/common/i18n'
import Bugsnag from '@bugsnag/js'
import { Notify } from 'quasar'

import type { BackErrors } from 'types/common/error/error'
import type { CallToActionType } from 'types/common/cta'

export const useErrorStore = defineStore('error', {
  state: () => ({
    // Cleaned on every route change
    backErrors: {} as { [key: string]: string },
    callToAction: {} as { [key: string]: CallToActionType },
    // /!\ NOT cleaned on every route change
    frontErrors: {} as { [key: string]: string },
    generalErrorMsg: '',
  }),

  actions: {
    updateBackErrors(
      error: unknown,
      errorType = 'generalError',
      prefixViolation = false,
      show402 = false
    ) {
      const errors: { [key: string]: string } = {}
      if (axios.isAxiosError(error) && error.response) {
        const axiosRes = error.response as BackErrors

        if (axiosRes.status === 403) {
          this.generalErrorMsg = $t('error.auth.notAuthorized')
          Notify.create({
            message: $t('error.auth.notAuthorized'),
            color: 'negative',
            position: 'top',
          })
        } else if (axiosRes.status === 409) {
          axiosRes.data.payload?.violations?.forEach((el) => {
            if (!errors[el.property_path]) {
              errors[
                (prefixViolation
                  ? `${errorType}.${el.property_path}`
                  : el.property_path) || errorType
              ] = el.message
            }
          })
        } else if (show402 || axiosRes.status !== 402) {
          errors[errorType] = axiosRes.data.payload?.message
          // BUGSNAG
          if (
            process.env.PROD &&
            (axiosRes.status === 404 || axiosRes.status === 500)
          ) {
            Bugsnag.notify(error)
          }
        }
      }
      this.backErrors = errors
    },

    removeError(model: string) {
      delete this.backErrors[model]
    },

    removeCta(cta: string) {
      delete this.callToAction[cta]
    },

    async chatNotification(e: string) {
      try {
        await axios.post(process.env.GOOGLE_CHAT_WEBHOOK_URL_ALERT ?? '', {
          text: e,
        })
      } catch {
        //
      }
    },
  },
})
